
export const getIsPageReimbursement = (pathname: string): boolean => {
  return pathname?.includes('/reimbursement/') ? true : false;
};
